@if (isLinkEnabled()) {
<a [href]="link" target="_blank">{{ task.orderId }}</a>
} @if (!isLinkEnabled()) {
<span [ngClass]="resultsDeliveryFailed() ? 'error' : ''">{{
  task.orderId
}}</span>
}
